module["exports"] = ["30[0-5]#-######-###L", "36##-######-###L", "54##-####-####-###L"];